import dayjs from "dayjs";

// Keep in sync with ROW_HEIGHT in ReservationTimelineContainer.jsx.
export const ROW_HEIGHT = 48;

export const getStatus = (reservation) => {
    if (!reservation.isApproved || reservation.isRejected) {
        return "rejected";
    }
    if (reservation.isCancelled) {
        return "cancelled";
    }
    if (reservation.isCarPickedUp && reservation.isCarDroppedOff) {
        return "completed";
    }
    if (reservation.isCarPickedUp && !reservation.isCarDroppedOff) {
        return "ongoing";
    }
    if (!reservation.isCarPickedUp && !reservation.isCarDroppedOff) {
        return "upcoming";
    }
    return "";
};

const formatReservations = (reservations) => {
    const items = [];
    const groups = [];
    const carMap = new Map();

    reservations?.forEach((reservation) => {
        const carId = reservation?.carId;
        const carName = reservation?.carName;
        const status = getStatus(reservation);

        if (!carMap?.has(carId)) {
            carMap.set(carId, true);
            groups.push({
                id: carId,
                title: carName,
                height: ROW_HEIGHT,
            });
        }

        const isReturnToday = status === "ongoing" && dayjs(reservation.dropoffDate).isSame(dayjs(), "day");

        items.push({
            id: reservation.id,
            customerName: reservation.customerName,
            group: carId,
            status,
            title: status?.toUpperCase(),
            isReturnToday,
            start_time: dayjs(reservation.pickupDate).valueOf(),
            end_time: dayjs(reservation.dropoffDate).valueOf(),
            rawReservation: reservation,
        });
    });

    return { groups, items };
};

export default formatReservations;
